import React from 'react'
import { Card, CardContent, Typography } from '@material-ui/core'
import { darken } from '@material-ui/core/styles/colorManipulator'
import { FuseAnimate } from '@fuse'
import { Link } from 'react-router-dom'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import RegisterBox from './RegisterBox'

const useStyles = makeStyles((theme) => ({
    root: {
        background: `linear-gradient(to right, ${theme.palette.primary.dark} 0%, ${darken(theme.palette.primary.dark, 0.5)} 100%)`,
        color: theme.palette.primary.contrastText,
    },
}))

function Register() {
    const classes = useStyles()

    return (
        <div className={clsx(classes.root, 'flex flex-col flex-1 flex-shrink-0 p-24 md:flex-row md:p-0')}>
            <div className="flex flex-col flex-grow-0 items-center text-white p-16 text-center md:p-128 md:items-start md:flex-shrink-0 md:flex-1 md:text-left">
                <div className="flex justify-center items-center ">
                    <FuseAnimate animation="transition.expandIn" className="flex items-center">
                        <img className="h-48 " src="assets/runningman_logo_s.png" alt="logo_venus_small" />
                    </FuseAnimate>
                    <FuseAnimate animation="transition.slideUpIn" delay={300}>
                        <Typography variant="h4" color="inherit" className="font-bold ml-3">
                            런닝맨 관리자
                        </Typography>
                    </FuseAnimate>
                </div>

                <FuseAnimate delay={400}>
                    <Typography variant="subtitle1" color="inherit" className="max-w-512 mt-16">
                        런닝맨 관리자 회원 가입 입니다.
                        <br />
                        등록 후 담당자에게
                        <span className="text-red font-bold"> 권한 부여를 요청</span>
                        하세요.
                    </Typography>
                </FuseAnimate>
            </div>

            <FuseAnimate animation={{ translateX: [0, '100%'] }}>
                <Card className="w-full max-w-400 mx-auto m-16 md:m-0" square={true}>
                    <CardContent className="flex flex-col items-center justify-center p-32 md:p-48 md:pt-128 ">
                        <Typography variant="h6" className="md:w-full mb-32 text-center">
                            관리자 회원 가입
                        </Typography>

                        <RegisterBox />
                        <div className="flex flex-col items-center justify-center pt-32 pb-24">
                            <Link className="font-medium" to="/login">
                                로그인
                            </Link>
                        </div>

                        <div className="flex flex-col items-center" />
                    </CardContent>
                </Card>
            </FuseAnimate>
        </div>
    )
}

export default Register
